import React from 'react'

function AddSalesOrder() {
  return (
    <div>AddSalesOrder</div>
  )
}

export default AddSalesOrder